import { OrderManagementRightMenuStructure } from "../store";
import { ORDER_MANAGEMENT_RIGHT_MENU } from '../actions-constants/orderManagementRightMenu.constants'
const initialOrderManagementRightMenu: OrderManagementRightMenuStructure = new OrderManagementRightMenuStructure

export function orderManagementRightMenuReducer(orderManagementRightMenu: OrderManagementRightMenuStructure = initialOrderManagementRightMenu, action): OrderManagementRightMenuStructure {

  switch (action.type) {
    case ORDER_MANAGEMENT_RIGHT_MENU.SET_INITIAL_DATE:
      return {
        ...orderManagementRightMenu,
        initialDate: action.initialDate
      }

    case ORDER_MANAGEMENT_RIGHT_MENU.SET_FINAL_DATE:
      return {
        ...orderManagementRightMenu,
        finalDate: action.finalDate
      }

    case ORDER_MANAGEMENT_RIGHT_MENU.SET_STATE_SITUATIONS:
      return {
        ...orderManagementRightMenu,
        stateSituations: action.stateSituations
      }

    case ORDER_MANAGEMENT_RIGHT_MENU.SET_STATE_LIST_MENU_SELECTIONS:
      return {
        ...orderManagementRightMenu,
        stateListMenuSelections: action.stateListMenuSelections
      }
    case ORDER_MANAGEMENT_RIGHT_MENU.SET_FILTERS_APPLIED_ORDER_MANAGEMENT:
      return {
        ...orderManagementRightMenu,
        filtersAppliedOrderManagement: action.filtersAppliedOrderManagement
      }
    case ORDER_MANAGEMENT_RIGHT_MENU.SET_LIST_STATE_ORIGIN:
      return {
        ...orderManagementRightMenu,
        stateListOrigin: action.stateListOrigin
      }
    default:
      return orderManagementRightMenu
  }
}
